import { useContext } from 'react';
import { ThemeContext } from '@/contexts/ThemeContext';
import { Toaster } from '@matrix-forge/ui/components/sonner';

export const AppToaster = () => {
  const { theme } = useContext(ThemeContext);
  return <Toaster theme={theme as 'light' | 'dark' | undefined} />;
};
